import React from 'react';
import {
  Box,
  Button,
  ButtonBase,
  ButtonBaseProps,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from '@mui/material';
import {
  AccountApiResponse,
  ChildProfilePageStep,
  CommonPageStep,
} from '../..';
import { verifyDataFormat } from '../../../common/CommonTools';
import { appConfig } from '../../../common/ConfigLoader';
import { useAppSelector } from '../../../store/hooks';
import {
  AppStateAuthentication,
  selectAppAuthentication,
  setAppPageStep,
  updateAppAuthentication,
} from '../../../store/reducer/appStateSlice';
import {
  selectChildProfileData,
  setChildProfileData,
} from '../../../store/reducer/childProfileDataSlice';
import { outsideComponentDispatch } from '../../../store/store';

export interface CreatedElementInterface {
  avatar: JSX.Element;
  childNameLabel: string;
  nextButton: JSX.Element;
  backButton: JSX.Element;
}

export const CreatedElement = (): CreatedElementInterface => {
  // Redux
  const childProfileData = useAppSelector(selectChildProfileData);
  const authenticationData = useAppSelector(selectAppAuthentication);

  // Hooks
  const [nextPressed, setNextPressed] = React.useState(false);

  // Handlers
  return {
    avatar: (
      <React.Fragment>
        <Box
          style={{
            position: 'relative',
            width: '200px',
            height: '200px',
            userSelect: 'none',
            WebkitUserSelect: 'none',
          }}
        >
          <img
            alt=""
            src={`assets/childProfile/${childProfileData.avatar}.svg`}
            style={{
              position: 'absolute',
              left: '0px',
              width: '200px',
              height: '200px',
              userSelect: 'none',
              WebkitUserSelect: 'none',
            }}
          />
        </Box>
      </React.Fragment>
    ),
    childNameLabel: childProfileData.firstname,
    nextButton: (
      <Button
        variant="contained"
        fullWidth={true}
        disabled={nextPressed}
        onClick={() => {
          // DISABLED THE BUTTON FOR A WHILE
          setNextPressed(true);

          setTimeout(() => {
            setNextPressed(false);
          }, 5000);

          // TO-DO: GO TO BIG BANG LAB
          outsideComponentDispatch(setAppPageStep(CommonPageStep.BIGBANGLAB));
        }}
      >
        Next
      </Button>
    ),
    backButton: (
      <Button
        variant="text"
        fullWidth={true}
        disabled
        onClick={() => {
          outsideComponentDispatch(setAppPageStep(ChildProfilePageStep.CREATE));
        }}
      >
        Back
      </Button>
    ),
  };
};
